module.exports = __webpack_public_path__ + "static/avatar.1152bc7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/global/assets/avatar.jpg
// module id = 176
// module chunks = 35783957827783 103869943198658